(function () {
  let sliders = document.querySelectorAll('.js-slideshow__section');

  Array.prototype.forEach.call(sliders, function (slider) {
    let current = 0;

    let slides = slider.querySelectorAll('.js-slideshow__slide');
    let pages = slider.querySelectorAll('.js-slideshow__page');

    if (slides.length > 0 && slider.dataset.autoplay === 'true') {
      setInterval(nextSlide, +slider.dataset.autoplaySpeed * 1000);
    }

    Array.prototype.forEach.call(pages, (page, i) => {
      page.addEventListener('click', () => {
        gotoSlide(i);
      });
    });

    const prev = slider.querySelector('.js-slideshow__page--prev');
    if (prev) prev.addEventListener('click', prevSlide);

    const next = slider.querySelector('.js-slideshow__page--next');
    if (next) next.addEventListener('click', nextSlide);

    
    let hammer = new Hammer(slider);

    hammer.on('swipeleft', function() {
      nextSlide();
    });

    hammer.on('swiperight', function() {
      prevSlide();
    });


    function gotoSlide(i) {
      if (i >= slides.length) return;

      slides[current].classList.remove('slideshow__slide--active');
      slides[i].classList.add('slideshow__slide--active');

      if (pages.length) {
        pages[current].classList.add('slideshow__page');
        pages[current].classList.remove('slideshow__page--active');

        pages[i].classList.add('slideshow__page--active');
        pages[i].classList.remove('slideshow__page');
      }

      current = i;
    }

    function nextSlide() {
      if (current + 1 >= slides.length) {
        gotoSlide(0);
      } else {
        gotoSlide(current + 1);
      }
    }

    function prevSlide() {
      if (current === 0) {
        gotoSlide(slides.length - 1);
      } else {
        gotoSlide(current - 1);
      }
    }
  });
})();

setTimeout(function () {
  jQuery(document).ready(function () {
    $('[href="#featured-pages-section"]').click(function (e) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: $('#featured-pages-section').offset().top - 100,
        },
        500
      );
    });

    
  });
}, 500);
